import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { RoleStore } from '@/store/role.store';
import type { Role } from '@/models/role.model';

export function roleGuard(allowedRoles: Role[]): CanActivateFn {
  return () => {
    const roleStore = inject(RoleStore);
    const router = inject(Router);

    const activeRole = roleStore.activeRole();
    if (allowedRoles.includes(activeRole)) {
      return true;
    }

    const assigned = roleStore.assignedRoles();
    const matchingRole = allowedRoles.find((r) => assigned.includes(r));
    if (matchingRole) {
      roleStore.setActiveRole(matchingRole);
      return true;
    }

    router.navigate(['/']).then();
    return false;
  };
}
